/**
 * Firebase web app "Bundle Web" (project bigsmall-bundle): config/firebase/web.json is the single source, imported by
 * the app and by the service worker (public identifiers, safe in client code). Nothing else here (no SDK, no
 * import.meta.env), so the service worker can import it as is.
 */
import type { FirebaseOptions } from "firebase/app";
import web from "../../../../../config/firebase/web.json";

const { $description: _about, vapidKey, ...options } = web;

export const firebaseOptions: FirebaseOptions = options;
/** Web Push (VAPID) public key from Cloud Messaging → Web Push certificates (public by design). */
export const webPushVapidKey: string = vapidKey;
